// import React, { useRef } from "react";
// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
// import cpyIcon from "../../assets/icons/Copy.png";

// export default function CodeBlockWithCopy({ language, value }) {
//   const codeRef = useRef(null);

//   const handleCopy = () => {
//     if (codeRef.current) {
//       navigator.clipboard.writeText(codeRef.current.innerText);
//     }
//   };

//   return (
//     <div style={{ position: "relative" }}>
//       <button
//         onClick={handleCopy}
//         // className="border border-1 border-white"
//         style={{
//           position: "absolute",
//           right: "4px",
//           top: "4px",
//           padding: "5px 10px",
//           fontSize: "12px",
//           cursor: "pointer",
//           borderRadius: "6px",
//           background: "transparent",

//           color: "white",
//           border: "none",
//           zIndex: "999",
//         }}
//       >
//         <img
//           src={cpyIcon}
//           className="icon-image"
//           alt="Copy"
//           role="button"
//           title="Copy"
//           // onClick={() => handleCopy(msg.message)}
//           style={{ width: "16px", height: "16px", cursor: "pointer" }}
//         />
//         {" "}
//          Copy code
//       </button>

//       <div ref={codeRef}>
//         <SyntaxHighlighter
//           language={language || "text"}
//           style={oneDark}
//           customStyle={{
//             borderRadius: "10px",
//             padding: "1rem",
//             marginTop: "10px",
//           }}
//         >
//           {value}
//         </SyntaxHighlighter>
//       </div>
//     </div>
//   );
// }
import React, { useRef, useState } from "react";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import cpyIcon from "../../assets/UserIcons/Copy.svg";
import tickIcon from "../../assets/icons/icons_tick.png"; // your tick icon

export default function CodeBlockWithCopy({ language, value }) {
  const codeRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);

      // Reset after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={handleCopy}
        style={{
          position: "absolute",
          right: "4px",
          top: "4px",
          padding: "5px 10px",
          fontSize: "12px",
          cursor: "pointer",
          borderRadius: "6px",
          background: "rgba(255,255,255,0.08)",
          color: "white",
          border: "1px solid rgba(255,255,255,0.15)",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          backdropFilter: "blur(4px)",
          zIndex: 10,
        }}
      >
        <img
          src={copied ? tickIcon : cpyIcon}
          // className="icon-image"
          alt={copied ? "Copied" : "Copy"}
          style={{
            width: "16px",
            height: "16px",
            filter: "brightness(0) invert(1)",
          }}
        />
        {copied ? "Copied" : "Copy Code"}
      </button>

      <div ref={codeRef}>
        <SyntaxHighlighter
          language={language || "text"}
          style={oneDark}
          customStyle={{
            borderRadius: "10px",
            padding: "1rem",
            marginTop: "10px",
          }}
        >
          {value}
        </SyntaxHighlighter>
      </div>
    </div>
  );
}
